export default __webpack_public_path__ + "static/colour-reno-infographic-761e6f031a14c1df87a4a8b00f7471e1.png";